"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _Partner = require("../../contexts/Partner");
var _Container = _interopRequireDefault(require("../Container"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Logo = _interopRequireDefault(require("../Header/Logo"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FooterLogo = function FooterLogo(_ref) {
  var style = _ref.style;
  var _useContext = (0, _react.useContext)(_Partner.PartnerContext),
    isWl = _useContext.isWl;
  var styles = {
    footerLogo: {
      backgroundColor: _userflow["default"].colors.black,
      color: _userflow["default"].colors.white
    }
  };
  var footerLogoStyles = _objectSpread(_objectSpread({}, style), isWl ? styles.footerLogo : {});
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: footerLogoStyles
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 13
  }), "\u0421 \u043D\u0430\u0438\u043B\u0443\u0447\u0448\u0438\u043C\u0438 \u043F\u043E\u0436\u0435\u043B\u0430\u043D\u0438\u044F\u043C\u0438,", /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 11
  }), /*#__PURE__*/_react["default"].createElement(_Logo["default"], null), isWl && /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 18
  }));
};
FooterLogo.defaultProps = {
  style: {}
};
FooterLogo.propTypes = {
  style: _propTypes["default"].shape({})
};
var _default = exports["default"] = FooterLogo;